import { Reveal, SectionHeading } from "./Reveal";
import { SEVEN_DAYS } from "@/data/content";

const SevenDayProgram = () => (
  <section id="seven-day" data-testid="seven-day-section" className="py-20 lg:py-28 bg-gradient-to-b from-white to-brand-light scroll-mt-24">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <SectionHeading
        align="center"
        eyebrow="The IQMIZE 7-Day Student Program"
        title="A structured seven-day learning cycle."
        description="Each day introduces a different aspect of effective learning — building a routine students can repeat every week."
      />

      <div className="relative mt-16 max-w-3xl mx-auto" data-testid="seven-day-timeline">
        <div className="absolute left-6 lg:left-1/2 top-0 bottom-0 w-px bg-brand/25 lg:-translate-x-1/2" />
        <div className="space-y-8">
          {SEVEN_DAYS.map((d, i) => (
            <Reveal key={d.day} delay={i * 0.06}>
              <div
                data-testid={`seven-day-${d.day}`}
                className={`relative flex items-start gap-6 lg:w-1/2 ${
                  i % 2 === 0 ? "lg:pr-12 lg:ml-0" : "lg:pl-12 lg:ml-auto"
                } pl-16 lg:pl-0 ${i % 2 === 0 ? "" : "lg:pl-12"}`}
              >
                <div
                  className={`absolute left-6 lg:left-auto top-1 flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-full border-4 border-white bg-brand text-white shadow-md ${
                    i % 2 === 0 ? "lg:right-0 lg:translate-x-1/2 lg:left-auto" : "lg:left-0 lg:-translate-x-1/2"
                  }`}
                >
                  <span className="text-sm font-extrabold">{d.day}</span>
                </div>
                <div className="w-full rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
                  <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand">Day {d.day}</p>
                  <h3 className="mt-2 text-xl font-bold tracking-tight text-slate-900 uppercase">{d.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{d.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default SevenDayProgram;
